// SortingTable.js
import React, { useEffect, useState } from "react";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import "./stylesSortingTable.css";

import CategoryRow from "../CategoryRow/CategoryRow";

const SortingTable = ({
  columns,
  data,
  setData,
  toggleStatus,
  removeGame,
  setRemovingGameData,
  etype,
  allGames,
  addGameInCasinoEntity,
  toggleCasinoEntityStatus,
  changeCasinoEntityOrder,
  EditGameIcon,
  rows
}) => {
  const casinoGames = data;

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );

  const handleDragEnd = async (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = casinoGames.findIndex((c) => c.id === active.id);
      const newIndex = casinoGames.findIndex((c) => c.id === over.id);
      setData(arrayMove(casinoGames, oldIndex, newIndex));
      await changeCasinoEntityOrder({
        name: active.id,
        order: newIndex + 1,
        etype: etype,
      });
      console.log("MOVED", active.id, newIndex, etype);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={casinoGames.map((c) => c.id)}
        strategy={verticalListSortingStrategy}
      >
        <table className="sorting-table">
          <thead>
            <tr className="sorting-table-header-row">
              {columns.map((column, idx) => {
                return (
                  <th key={`${column}-${idx}`} className="sorting-table-header-cell">
                    <div className="sorting-table-header-cell-content">
                      <span>{column}</span>
                    </div>
                  </th>
                );
              })}
              <th className="sorting-table-header-cell">
                <div className="sorting-table-header-cell-content"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {casinoGames.map((category, index) => (
              <CategoryRow
                key={category.id}
                category={category}
                setCasinoGames={setData}
                order={index + 1}
                toggleStatus={toggleStatus}
                removeGame={removeGame}
                setRemovingGameData={setRemovingGameData}
                etype={etype}
                allGames={allGames}
                addGameInCasinoEntity={addGameInCasinoEntity}
                categories={data}
                toggleCasinoEntityStatus={toggleCasinoEntityStatus}
                EditGameIcon={EditGameIcon}
                rows={rows}
                columns={columns}
              />
            ))}
          </tbody>
        </table>
      </SortableContext>
    </DndContext>
  );
};

export default SortingTable;

